module.exports = "/images/no-interactions.svg?d103459c30d00c9fed2d255a28c5224c";